export const hotRankings = [
  { id: "r1", rank: 1, title: "年度榜单名次争议持续发酵，多个话题并入同一条讨论线", tag: "今日热瓜", heat: 986000, trend: "up" },
  { id: "r2", rank: 2, title: "代言合约变动传闻登上热搜，双方暂未公开回应", tag: "圈内爆料", heat: 812000, trend: "up" },
  { id: "r3", rank: 3, title: "新剧开机路透曝光，剧组成员当日状态被集中讨论", tag: "明星动态", heat: 724000, trend: "flat" },
  { id: "r4", rank: 4, title: "社交平台动态被秒删，截图已在多个话题下流传", tag: "圈内爆料", heat: 689000, trend: "up" },
  { id: "r5", rank: 5, title: "红毯造型合集出图，几套高讨论度造型被大量转发", tag: "明星动态", heat: 641000, trend: "down" },
  { id: "r6", rank: 6, title: "音乐节后台画面流出，彩排顺序临时调整被观众察觉", tag: "综艺现场", heat: 558000, trend: "flat" },
  { id: "r7", rank: 7, title: "综艺正片与预告剪辑差异被逐帧对比，剪辑版本成焦点", tag: "综艺现场", heat: 512000, trend: "up" },
  { id: "r8", rank: 8, title: "某剧组深夜收工被拍，主创同行画面引来新一轮猜测", tag: "影视幕后", heat: 483000, trend: "down" },
];

export const siteStats = [
  { id: "st1", value: "6", unit: "条", label: "在线可用线路" },
  { id: "st2", value: "24", unit: "次", label: "今日地址更新" },
  { id: "st3", value: "1286", unit: "个", label: "话题内容覆盖" },
  { id: "st4", value: "0.6", unit: "s", label: "平均访问延迟" },
];